import { FormbirdInjectorService } from '@services/injector/formbird-injector.service';
import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {ComponentDefinition} from '@formbird/types';
import {ChangedDocumentService} from 'formbird-services';
import {DomSanitizer} from '@angular/platform-browser';
import QRCode from 'qrcode';
import {ComponentSetupService} from '../../../../formbird-sc-shared/src/lib/component-setup.service';
import {AbstractComponent} from '../../../../formbird-sc-shared/src/lib/components/abstract.component';
import {MatTooltip} from '@angular/material/tooltip';
import {MatFormField} from '@angular/material/form-field';

interface QrCodeGeneratorComponentDefinition extends ComponentDefinition {
  caption?: string;
  onClick?: string;
  style?: string;
  floatLabel?: any;
  hideQrText?: any;
}

@Component({
  templateUrl: './q-r-code-generator.component.html',
  styleUrls: ['./q-r-code-generator.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class QrCodeGeneratorComponent extends AbstractComponent<QrCodeGeneratorComponentDefinition> implements OnInit {

  @Input() floatLabel: any;
  fullWidth: any;
  base64Image: any;
  oldDocQrText: any;

  constructor(
    protected formbirdInjectorService: FormbirdInjectorService,
    private domSanitizer: DomSanitizer,
    protected changedDocumentService: ChangedDocumentService,
    protected componentSetupService: ComponentSetupService,
    protected cdr: ChangeDetectorRef
  ) {
    super(formbirdInjectorService, changedDocumentService, componentSetupService, cdr);
  }

  private async generateQrCode(qrText) {
    if (!qrText) {
      return;
    }

    const instance = this;
    this.oldDocQrText = qrText;
    QRCode.toDataURL(qrText, {errorCorrectionLevel: 'H'}, (err, url) => {
      if (!err) {
        instance.base64Image = instance.domSanitizer.bypassSecurityTrustUrl(url);
      } else {
        instance.base64Image = null;
        console.log(err.message);
      }
      this.detectChanges();

    });
  }

  async changeQrImage() {
    this.generateQrCode(this.fieldValue);
  }

  ngOnInit() {

    if (!(typeof this.componentDefinition.floatLabel === 'undefined' || this.componentDefinition.floatLabel === null)) {
      this.componentDefinition.floatLabel = 'always';
    }

    this.shouldNotifyCompInitializedInSuper = false;

    super.ngOnInit();

    this.generateQrCode(this.fieldValue);

  }

  onFieldValueChanged(fieldValue) {
    if (this.fieldValue === fieldValue) {
      return;
    }
    this.fieldValue = fieldValue;
    this.formControl.patchValue(this.fieldValue, {emitEvent: false, onlySelf: true});
    this.generateQrCode(this.fieldValue);
    this.detectChanges();
  }

  valueChanged(value) {
    this.generateQrCode(value);

    super.valueChanged(value);
  }

  showToolTip(tooltip: MatTooltip, formFieldContainer: MatFormField, labelContainer: HTMLElement) {
    return (labelContainer.offsetWidth <= formFieldContainer._elementRef.nativeElement.scrollWidth);
  }

  toggleTooltip(tooltip: MatTooltip) {
    setTimeout(() => {
      tooltip.toggle();
    });
  }
}

